import React, { createContext } from 'react';
export var CollectionPageContext = createContext({ isCollection: false });
/**
 * A context provider that tells consumers if they are rendering inside a collection page
 */
var CollectionPageContextProvder = function (_a) {
    var _b = _a.isCollection, isCollection = _b === void 0 ? false : _b, children = _a.children;
    return (React.createElement(CollectionPageContext.Provider, { value: { isCollection: isCollection } }, children));
};
export default CollectionPageContextProvder;
